<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="purchasecontract" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="合同编号">
        <template slot-scope="scope">
          <el-link type="primary" @click="() => {
              handleDetail(scope.row);
            }
            ">
            {{ scope.row.Code }}
          </el-link>
          <br />
          <el-link type="primary" @click="() => {
              currentRow = scope.row;
              handleHistry();
            }
            ">
            版本记录:{{ scope.row.PriceVer }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="SupplierName" label="供应商" sortable></el-table-column>

      <el-table-column prop="Remark" label="备注" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatDate" sortable></el-table-column>
      <el-table-column prop="CreateUser" label="创建者" sortable></el-table-column>
      <el-table-column prop="Status" label="状态" width="" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Status == 0 ? 'success' : 'info'" disable-transitions>
            {{ scope.row.Status == 0 ? "正常" : "归档" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canEdit" type="primary" @click="() => {
              currentRow = scope.row;
              handleEdit();
            }
            ">
            编辑
          </el-link>
          <el-link v-if="canDelete" type="danger" @click="() => {
              sels.push(scope.row);
              handleDel();
            }
            ">
            删除
          </el-link>
          <el-link v-if="canFiled" type="danger" @click="() => {
              currentRow = scope.row;
              handleFiled();
            }
            ">
            归档
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--新增界面-->
    <el-dialog :title="isEdit ? '编辑' : '新增'" :visible.sync="addFormVisible" v-model="addFormVisible"
      :close-on-click-modal="false" width="80%">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-tabs v-model="activeName">
          <el-tab-pane label="基本信息" name="one">
            <el-divider content-position="left">出售方</el-divider>
            <el-row>
              <el-col :span="12">
                <el-form-item label="供应商">
                  <el-input v-model="addForm.Purchasecontract.SupplierName" readonly class="hr-select">
                    <template slot="append">
                      <el-button class="pd-5" type="primary" @click="suppvisibleDialog = true">
                        选择
                      </el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="备注">
                  <el-input v-model="addForm.Purchasecontract.Remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人">
                  <el-input v-model="addForm.Purchasecontract.ContactName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话">
                  <el-input v-model="addForm.Purchasecontract.ContactPhone"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="采购员">
                  <el-input v-model="addForm.Purchasecontract.PurchasePersonName" readonly class="hr-select">
                    <template slot="append">
                      <el-button class="pd-5" type="primary" @click="hrvisibleDialog = true">
                        选择
                      </el-button>
                    </template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="签订时间">
                  <el-date-picker v-model="addForm.Purchasecontract.SignDate" type="datetime" placeholder="选择日期时间"
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="开始时间">
                  <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.Purchasecontract.DateStart"
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="结束时间">
                  <el-date-picker type="datetime" placeholder="选择日期" v-model="addForm.Purchasecontract.DateEnd"
                    value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="更新磅单">
                  <el-switch v-model="addForm.Purchasecontract.IsHistryEffect" active-color="#13ce66"
                    inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="采购详情" name="two">
            <div ref="detail-title" class="detail-item">
              <div>开始日期</div>
              <div>结束日期</div>
              <div>物资</div>
              <div>单位</div>
              <div>单价</div>
              <div>运费</div>
              <div>运输单位</div>
              <div>产地</div>
            </div>
            <div v-for="(item, index) in addForm.PurchasecontractSubList" :key="index" :ref="`detail-item${index}`"
              class="detail-item" @scroll="exterHandleScroll(index)">
              <el-date-picker type="datetime" placeholder="开始日期" v-model="item.DateStart"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              <el-date-picker type="datetime" placeholder="结束日期" v-model="item.DateEnd"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>

              <el-select v-model="item.MatID" @change="matChange(item.MatID, index)">
                <el-option v-for="material in basedata.MaterialList" :label="material.Name" :key="material.Id + '_mat'"
                  :value="material.Id" v-model="material.Id"></el-option>
              </el-select>

              <el-select v-model="item.UnitID" @change="unitChange(item.UnitID, index)">
                <el-option v-for="unit in basedata.MatUnitList" :label="unit.Name" :key="unit.Id + '_dw'" :value="unit.Id"
                  v-model="unit.Id"></el-option>
              </el-select>

              <el-input v-model="item.Price"></el-input>

              <el-input v-model="item.TransitPrice"></el-input>

              <el-select v-model="item.TransportID" @change="transportChange(item.TransportID, index)">
                <el-option v-for="Transpor in basedata.TransportList" :label="Transpor.Name" :key="Transpor.Id + '_ys'"
                  :value="Transpor.Id" v-model="Transpor.Id"></el-option>
              </el-select>

              <el-select v-model="item.PlaceOfOriginID" @change="placeOfChange(item.PlaceOfOriginID, index)">
                <el-option v-for="placeOf in basedata.PlaceOfOriginList" :label="placeOf.Name" :key="placeOf.Id + '_cd'"
                  :value="placeOf.Id" v-model="placeOf.Id"></el-option>
              </el-select>

              <el-button type="danger" @click="removeRow(item.Id)">
                删除
              </el-button>
            </div>
            <el-row>
              <el-button @click="addRow">新增行</el-button>
            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>

    <!-- 历史配比列表 -->
    <el-dialog title="历史列表" :visible.sync="histryShow" v-model="histryShow" :close-on-click-modal="false" append-to-body>
      <!--历史列表-->
      <el-table :data="histryData" highlight-current-row v-loading="listLoading" style="width: 100%">
        <el-table-column label="编号">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.Code }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="SupplierName" label="供应商" sortable></el-table-column>
        <el-table-column prop="PriceVer" label="版本号" sortable></el-table-column>
        <el-table-column prop="CreateUser" label="创建人" sortable></el-table-column>
        <el-table-column prop="CreateTime" label="创建时间" sortable></el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="histrypageSize" :total="histrytotal"
        @current-change="histryCurrentChange" @size-change="histrySizeChange" class="my-pagination"></el-pagination>
    </el-dialog>
    <!-- 详情 -->
    <el-dialog :title="PurchasecontractDetail.Purchasecontract.Code" :visible.sync="isShowPurchasecontractDetailPage">
      <table class="table-bordered">
        <tr>
          <th>供应商选择</th>
          <td>{{ PurchasecontractDetail.Purchasecontract.SupplierName }}</td>
          <th>备注</th>
          <td>{{ PurchasecontractDetail.Purchasecontract.Remark }}</td>
        </tr>
        <tr>
          <th>联系人</th>
          <td>{{ PurchasecontractDetail.Purchasecontract.ContactName }}</td>
          <th>联系电话</th>
          <td>{{ PurchasecontractDetail.Purchasecontract.ContactPhone }}</td>
        </tr>
        <tr>
          <th>采购员</th>
          <td>
            {{ PurchasecontractDetail.Purchasecontract.PurchasePersonName }}
          </td>
          <th>签订时间</th>
          <td>{{ PurchasecontractDetail.Purchasecontract.SignDate }}</td>
        </tr>
        <tr>
          <th>生效时间</th>
          <td>
            {{ PurchasecontractDetail.Purchasecontract.DateStart }}-{{
              PurchasecontractDetail.Purchasecontract.DateEnd
            }}
          </td>
          <th>签订时间</th>
          <td>{{ PurchasecontractDetail.Purchasecontract.SignDate }}</td>
        </tr>
      </table>
      <el-divider content-position="left">合同详情</el-divider>
      <el-table :data="PurchasecontractDetail.PurchasecontractSubList" border style="width: 100%">
        <el-table-column prop="DateStart" label="开始时间"></el-table-column>
        <el-table-column prop="DateEnd" label="结束时间"></el-table-column>
        <el-table-column prop="MatName" label="物资"></el-table-column>
        <el-table-column prop="UnitName" label="单位"></el-table-column>
        <el-table-column prop="Price" label="单价"></el-table-column>
        <el-table-column prop="TransitPrice" label="运费"></el-table-column>
        <el-table-column prop="TransportName" label="运输单位"></el-table-column>
        <el-table-column prop="PlaceOfOriginName" label="产地"></el-table-column>
      </el-table>
    </el-dialog>

    <TableDataDialog title="供应商" :visibleDialog="suppvisibleDialog" :queryMethod="suppqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="suppsetVisible" @callback="suppdialogCallback"></TableDataDialog>

    <TableDataDialog title="采购人员" :visibleDialog="hrvisibleDialog" :queryMethod="hrqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="hrsetVisible" @callback="hrdialogCallback"></TableDataDialog>
  </section>
</template>

<script>
import * as api from "../../api/purchasecontract";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TableDataDialog from "../../components/TableDataDialog";
import { getSupplierListPage } from "../../api/supplier";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
import util from "../../../util/date";
export default {
  components: { Toolbar, TableDataDialog },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      isEdit: false,
      filters: {
        name: "",
      },
      purchasecontract: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      basedata: [],
      sels: [], //列表选中列
      addDialogFormVisible: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        //Name: [{ required: true, message: "请输入单位名称", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Purchasecontract: {},
        PurchasecontractSubList: [],
      },
      visibleDialog: false,
      activeName: "one",
      suppvisibleDialog: false, //供应商列表选择
      hrvisibleDialog: false, //采购人员列表选择
      subIndex: 0, //子条目Id
      histryData: [], //历史记录
      histrytotal: 0, //历史记录翻页
      histrypage: 1,
      histrypageSize: 20,
      histryShow: false,
      isShowPurchasecontractDetailPage: false,
      PurchasecontractDetail: {
        Purchasecontract: {},
        PurchasecontractSubList: [],
      },
    };
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex((s) => s.name === "编辑");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canFiled() {
      let index = this.buttonList.findIndex((s) => s.name === "归档");
      return index > -1;
    },
  },
  methods: {
    next() {
      if (this.active++ > 2) this.active = 0;
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getPurchasecontract();
    },
    //获取列表
    getPurchasecontract() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getPurchasecontractListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.purchasecontract = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDeletePurchasecontract(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getPurchasecontract();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示编辑界面
    handleEdit() {
      this.activeName = "one";
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.isEdit = true;
      this.addFormVisible = true;
      let para = {
        id: row.Id,
      };
      api.getPurchasecontractDetail(para).then((res) => {
        this.addForm = res.data.response;
      });
    },
    //显示新增界面
    handleAdd() {
      this.activeName = "one";
      this.addFormVisible = true;
      this.isEdit = false;
      this.addForm = {
        Purchasecontract: {},
        PurchasecontractSubList: [],
      };
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            if (
              this.addForm.Purchasecontract.IsHistryEffect != undefined &&
              this.addForm.Purchasecontract.IsHistryEffect == 1
            ) {
              this.$confirm(
                "此操作将对" +
                this.addForm.Purchasecontract.DateStart +
                "到" +
                this.addForm.Purchasecontract.DateEnd +
                "是时间内过磅单价格进行修改,此操作可能耗时较久, 是否继续?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              )
                .then(() => {
                  api
                    .editPurchasecontract(para)
                    .then((res) => {
                      if (res && res.data && res.data.success) {
                        this.$message({
                          message: res.data.msg,
                          type: "success",
                        });
                        this.$refs["addForm"].resetFields();
                        this.addFormVisible = false;
                        this.getPurchasecontract();
                      } else {
                        this.$message({
                          message: res.data.msg,
                          type: "error",
                        });
                      }
                    })
                    .finally(() => {
                      this.addLoading = false;
                    });
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "操作取消",
                  });
                  this.addLoading = false;
                });
            } else {
              api
                .editPurchasecontract(para)
                .then((res) => {
                  if (res && res.data && res.data.success) {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    this.$refs["addForm"].resetFields();
                    this.addFormVisible = false;
                    this.getPurchasecontract();
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  }
                })
                .finally(() => {
                  this.addLoading = false;
                });
            }
          } else {
            this.isEdit = false;
            api
              .addPurchasecontract(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["addForm"].resetFields();
                  this.addFormVisible = false;
                  this.getPurchasecontract();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.addLoading = false;
              });
          }
        }
      });
    },
    //归档
    handleFiled() {
      this.editLoading = true;
      let para = Object.assign({}, this.currentRow);
      let user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
      } else {
        this.$message({
          message: "登录信息已过期,请重新登录",
          type: "error",
        });
        this.$router.replace(
          this.$route.query.redirect ? this.$route.query.redirect : "/"
        );
      }
      api
        .filedInfo(para)
        .then((res) => {
          if (res && res.data && res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getSaleContract();
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //翻页事件绑定方法
    histryCurrentChange(val) {
      this.histrypage = val;
      this.getHistry();
    },
    //获取历史列表
    getHistry() {
      let para = {
        page: this.histrypage,
        key: this.currentRow.Code,
        intPageSize: this.histrypageSize,
      };
      this.listLoading = true;
      api.getHistryByPage(para).then((res) => {
        this.histrytotal = res.data.response.dataCount;
        this.histryData = res.data.response.data;
        this.listLoading = false;
      });
    },
    //查看历史列表
    handleHistry() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      this.histryShow = true;
      this.getHistry();
    },
    //切换分页大小绑定方法
    histrySizeChange(size) {
      this.histrypageSize = size;
      this.getHistry();
    },
    // 显示窗口
    handleDetail(row) {
      let para = {
        id: row.Id,
      };
      api.getPurchasecontractDetail(para).then((res) => {
        if (!res.data.success) {
          this.PurchasecontractDetail = [];
          tihs.$message("获取失败");
          return;
        }
        this.PurchasecontractDetail = res.data.response;
      });
      this.isShowPurchasecontractDetailPage = !this
        .isShowPurchasecontractDetailPage;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;
      this.getPurchasecontract();
    },
    setVisible(val) {
      this.visibleDialog = val;
    },
    GetBaseData() {
      api.getPurchasecontractBaseData().then((res) => {
        this.basedata = res.data.response;
      });
    },
    suppdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.Purchasecontract.SupplierID = data[0].Id;
        this.addForm.Purchasecontract.SupplierName = data[0].Name;
      }
      this.suppvisibleDialog = false;
    },
    suppqueryData(params) {
      return getSupplierListPage(params);
    },
    suppsetVisible(val) {
      this.suppvisibleDialog = val;
    },
    hrdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.Purchasecontract.PurchasePersonID = data[0].Id;
        this.addForm.Purchasecontract.PurchasePersonName = data[0].Name;
      }
      this.hrvisibleDialog = false;
    },
    hrqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    hrsetVisible(val) {
      this.hrvisibleDialog = val;
    },
    //获取物料
    matChange(Id, index) {
      var matItem = this.basedata.MaterialList.filter((x) => x.Id == Id)[0];
      this.addForm.PurchasecontractSubList[index].MatName = matItem.Name;
      this.addForm.PurchasecontractSubList[index].MatID = Id;
    },
    //单位选择
    unitChange(Id, index) {
      var matItem = this.basedata.MatUnitList.filter((x) => x.Id == Id)[0];
      this.addForm.PurchasecontractSubList[index].UnitName = matItem.Name;
      this.addForm.PurchasecontractSubList[index].UnitID = Id;
      this.addForm.PurchasecontractSubList[index].ConvertRate =
        matItem.ConvertRate;
    },
    //运输单位选择
    transportChange(Id, index) {
      var matItem = this.basedata.TransportList.filter((x) => x.Id == Id)[0];
      this.addForm.PurchasecontractSubList[index].TransportName = matItem.Name;
      this.addForm.PurchasecontractSubList[index].TransportID = Id;
    },
    //产地选择
    placeOfChange(Id, index) {
      var matItem = this.basedata.PlaceOfOriginList.filter(
        (x) => x.Id == Id
      )[0];
      this.addForm.PurchasecontractSubList[index].PlaceOfOriginName =
        matItem.Name;
      this.addForm.PurchasecontractSubList[index].PlaceOfOriginID = Id;
    },

    //明细添加行
    addRow() {
      this.subIndex += 1;
      this.addForm.PurchasecontractSubList.push({ Id: this.subIndex });
    },
    //明细删除行
    removeRow(id) {
      this.addForm.PurchasecontractSubList.splice(
        this.addForm.PurchasecontractSubList.findIndex((x) => x.Id === id),
        1
      );
    },
    exterHandleScroll(index) {
      this.$refs["detail-title"].scrollLeft = this.$refs[
        `detail-item${index}`
      ][0].scrollLeft;
    },
  },
  mounted() {
    this.getPurchasecontract();
    this.GetBaseData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style lang="less" scoped>
.detail-item {
  display: flex;
  overflow-x: auto;
  align-items: center;
  margin-bottom: 20px;

  div {
    width: 200px;
    margin: 0 10px;
    padding: 10px 0;
    flex-shrink: 0;
  }
}
</style>
